import { action, makeObservable, observable } from 'mobx';
import moment, { Moment } from 'moment';
import { PaymentStates } from 'core/enums/payment-states';
import { PopupConfig, PopupData } from './popup-config';

export enum PopupLayout {
  DateSelector = 1,
  PaymentNotice = 2,
  AccountDetail = 3,
  ProfileImageUploader = 4,
  FixErrorProcessing = 5,
  UnlockSimInfo = 6,
  WelcomePopup = 7,
  BrandMissMatch = 8,
  Error = 9,
  PremiumExperiences = 10,
  PaymentReminder = 11,
  InAppGeneric = 12,
  ReconnectUpsize = 13,
}

export class PopupStore {
  isOpen = false;
  config!: PopupConfig;
  selectedImage!: string;
  isContentLoading = false;
  paymentInProgress = false;
  paymentState = PaymentStates.Pending;
  selectedDates!: {
    from: Moment;
    to: Moment;
  };
  viewingDaysLeft = 0;
  isDebitOrder = false;

  constructor() {
    makeObservable(this, {
      selectedDates: observable,
      selectedImage: observable,
      config: observable,
      isOpen: observable,
      isContentLoading: observable,
      paymentInProgress: observable,
      paymentState: observable,
      viewingDaysLeft: observable,
      isDebitOrder: observable,
      changeSelectedDates: action,
      changeSelectedImage: action,
      changeIsOpen: action,
      changeConfig: action,
      changeIsContentLoading: action,
      changePaymentInProgress: action,
      changePaymentState: action,
      changeViewingDaysLeft: action,
      changeIsDebitOrder: action,
    });
  }

  initialize(popupData: PopupData) {
    this.changeConfig(new PopupConfig(popupData));
    this.changeSelectedDates({
      from: popupData.fromDate || moment().subtract(6, 'months'),
      to: popupData.toDate || moment(),
    });
  }

  changeSelectedDates(selectedDates: { from: Moment; to: Moment }) {
    this.selectedDates = selectedDates;
  }

  changeSelectedImage(selectedImage: string) {
    this.selectedImage = selectedImage;
  }

  toggleIsOpen() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      document.body?.classList.add('is-modal-open');
    } else {
      document.body?.classList.remove('is-modal-open');
    }
  }

  changeIsOpen(isOpen: boolean) {
    this.isOpen = isOpen;
    if (this.isOpen) {
      document.body?.classList.add('is-modal-open');
    } else {
      document.body?.classList.remove('is-modal-open');
    }
  }

  changeConfig(config: PopupConfig) {
    this.config = config;
  }

  onAction() {
    this.config.fromDate = this.selectedDates.from;
    this.config.toDate = this.selectedDates.to;
    if (this.config.onAction) {
      switch (this.config?.template) {
        case PopupLayout.DateSelector:
          this.config.onAction(this.selectedDates);
          this.changeIsOpen(false);
          break;
        case PopupLayout.ProfileImageUploader:
          this.config.onAction(this.selectedImage);
          this.changeIsOpen(false);
          break;
        case PopupLayout.PaymentNotice:
          this.config.onAction();
          this.changeIsOpen(false);
          break;
        default:
          this.config.onAction();
          this.changeIsOpen(false);
          break;
      }
    }
  }

  defaultClose() {
    this.config.onClose && this.config.onClose();
    this.changeIsOpen(false);
    this.changePaymentInProgress(false);
    this.changeIsContentLoading(false);
  }

  changeIsContentLoading(_value: boolean) {
    this.isContentLoading = _value;
  }
  changePaymentInProgress(_value: boolean) {
    this.paymentInProgress = _value;
  }
  changePaymentState(_value: PaymentStates) {
    this.paymentState = _value;
  }
  changeViewingDaysLeft(_value: number) {
    this.viewingDaysLeft = _value;
  }
  changeIsDebitOrder(_value:boolean) {
    this.isDebitOrder = _value;
  }
}